import { render, staticRenderFns } from "./WaveRentTermMonth.vue?vue&type=template&id=2e352ad3&scoped=true&"
import script from "./WaveRentTermMonth.vue?vue&type=script&lang=js&"
export * from "./WaveRentTermMonth.vue?vue&type=script&lang=js&"
import style0 from "./WaveRentTermMonth.vue?vue&type=style&index=0&id=2e352ad3&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e352ad3",
  null
  
)

export default component.exports